module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tourFilter":"Filter by experience type","tourFilters":{"0":"All experiences","1":"Only tours","2":"Only VR experiences","3":"Only small VR experiences","4":"Only big VR experiences"}}}')
  delete Component.options._Ctor
}
